module.exports = __webpack_public_path__ + "assets/images/project/uae-desktop.jpg?v=2b1aa8f3";